import 'snapsvg'

import {
  Controls
} from './Controls.js'
import getBase64FromImageUrl from '../utils/getBase64FromImageUrl'
import formatPhoneNumber from '../utils/formatPhoneNumber'
import adjustFontSizeToFit from '../utils/adjustFontSizeToFit'
import adjustInfoVertical from '../utils/adjustInfoVertical'
import adjustLetterSpacing from '../utils/adjustLetterSpacing'
import adjustAname from '../utils/adjustAname'


export default class SVGEdit {
  constructor({
    svgView,
    controlView,
    photoUrl,
    logoUrl,
    content,
  }) {
    this.load = this.load.bind(this)
    this.parse = this.parse.bind(this)
    this.setContent = this.setContent.bind(this)
    this.setPhoto = this.setPhoto.bind(this)
    this.setLogo = this.setLogo.bind(this)
    this.getSVG = this.getSVG.bind(this)
    this.setSpacing = this.setSpacing.bind(this);
    this.svgView = svgView
    this.$svgView = document.querySelector(svgView)
    this.$controlView = document.querySelector(controlView)
    this.photoUrl = photoUrl
    this.logoUrl = logoUrl
    this.content = content
  }

  load(url) {
    this.$svgView.classList.add('si_svg-view')
    this.$controlView.classList.add('si_control-view')

    return new Promise((resolve) => {
      const svg = new Snap(this.svgView)

      Snap.load(url, (fragment) => {
        svg.append(fragment)
        this.svg = svg.select('svg')
        this.parse()
        resolve(this)
      })
    })
  }

  parse() {

    const Tempelements = [
      this.svg.select('#name text'),
      this.svg.select('#fname text'),
      this.svg.select('#lname text'),
      this.svg.select('#title text'),
      this.svg.select('#bphone text'),
      this.svg.select('#bmail text'),
      this.svg.select('#burl text'),
      this.svg.select('#photo image'),
      this.svg.select('#alogo image'),
      this.svg.select('#atitle text'),
      this.svg.select('#aname text'),
      this.svg.select('#aphone text'),

      this.svg.select('#input1 text'),
      this.svg.select('#input2 text'),
      this.svg.select('#input3 text'),
      this.svg.select('#input4 text'),
      this.svg.select('#input5 text'),
      this.svg.select('#date text'),

      this.svg.select('#namebis text'),
      this.svg.select('#fnamebis text'),
      this.svg.select('#lnamebis text'),
      this.svg.select('#titlebis text'),
      this.svg.select('#bphonebis text'),
      this.svg.select('#bmailbis text'),
      this.svg.select('#photobis image'),
      this.svg.select('#burlbis text'),
      this.svg.select('#alogobis image'),
      this.svg.select('#atitlebis text'),
      this.svg.select('#anamebis text'),
      this.svg.select('#aphonebis text'),

      this.svg.select('#input1bis text'),
      this.svg.select('#input2bis text'),
      this.svg.select('#input3bis text'),
      this.svg.select('#input4bis text'),
      this.svg.select('#input5bis text'),
      this.svg.select('#datebis text')
    ]
    var elements = [];

    Tempelements.forEach((tempElement) => {

      if (tempElement != null) {
        var config = tempElement.attr("si:can-config");
        if (config === 'true') {
          elements.push(tempElement);
        }
      }
    })

    this.photoElement = this.svg.select('#photo image')
    if (this.photoElement) {
      this.originalPhotoUrl = this.photoElement.attr('href') || this.photoElement.attr('xlink:href')
      this.setPhoto(this.photoUrl)
    }


    this.logoElement = this.svg.select('#alogo image')
    if (this.logoElement) {
      this.originalLogoUrl = this.logoElement.attr('href') || this.logoElement.attr('xlink:href')
      this.setLogo(this.logoUrl)
    }
    this.setSpacing()
    this.setContent(this.content)
    this.adjustVertical()
    this.adjustAnameAndTitle()


    elements.forEach((element) => {
      

      //if(element.hasAttribute('can-config')){
      const label = element.attr('si:config-label')
      const type = element.attr('si:config-type')
      //console.log(this.svg);
      const controls = new Controls(label, type, element, this.svg)
      this.$controlView.append(controls.getElement())
    })

    return this
  }

  setPhoto(photoUrl) {
    const xlinkns = 'http://www.w3.org/1999/xlink'

    if (this.photoElement) {
      this.photoElement.node.removeAttribute('href')
      this.photoElement.node.setAttributeNS(xlinkns, 'href', photoUrl)
      this.photoUrl = photoUrl
      //
      this.photoElementBis = this.svg.select('#photobis image')
      if (this.photoElementBis) {
        this.photoElementBis.node.removeAttribute('href')
        this.photoElementBis.node.setAttributeNS(xlinkns, 'href', photoUrl)
      }
      //
    } else {
      this.photoUrl = null
    }
  }
  adjustVertical(){
    
    this.binfo = this.svg.select("#binfo");
    if(this.binfo){
      adjustInfoVertical(this.svg, false, true);
      //adjustInfoVertical(this.svg, true, true)

    }
    
    this.binfobis = this.svg.select("#binfobis");
    if(this.binfobis){
      adjustInfoVertical(this.svg, true, true)
    }
  }
  adjustAnameAndTitle(){
    adjustAname(this.svg, '');
    adjustAname(this.svg, 'bis');
  }
  setLogo(logoUrl) {
    const xlinkns = 'http://www.w3.org/1999/xlink'

    if (this.logoElement && this.logoUrl) {
      this.logoElement.node.removeAttribute('href')
      this.logoElement.node.setAttributeNS(xlinkns, 'href', logoUrl)

      this.logoUrl = logoUrl
      //
      this.logoUrlBis = this.svg.select('#alogobis image')

      if (this.logoUrlBis) {
        this.logoUrlBis.node.removeAttribute('href')
        this.logoUrlBis.node.setAttributeNS(xlinkns, 'href', logoUrl)
      }
    } else {
      this.logoUrl = null
    }
  }
  setSpacing() {
    const styles = this.svg.selectAll('style');
    const regex = /st(\d{1,3})\{letter-spacing\:(\d+(?:[.]\d+)?)\;\}/g;
    styles.forEach((style) => {
      var str = style.node;
      var htm = str.innerHTML.replace(new RegExp(/st(\d{1,3})\{letter-spacing\:(\d+(?:[.]\d+)?)\;\}/, 'g'), 'st\$1{letter-spacing:\$2px;}')
      str.innerHTML = htm;
    });
    const textes = this.svg.selectAll('text');
    textes.forEach((texte) => {
      adjustLetterSpacing(texte);
    });
  }
  setContent(content) {
    this.svg.attr('xmlns:si', 'http://www.superimpression.com/si')

    const elements = {
      name: {
        label: 'Name',
        type: 'text',
        element: this.svg.select('#name text'),
        elementbis: '#namebis'
      },
      fname: {
        label: 'First name',
        type: 'text',
        element: this.svg.select('#fname text'),
        elementbis: '#fnamebis'
      },
      lname: {
        label: 'Last name',
        type: 'text',
        element: this.svg.select('#lname text'),
        elementbis: '#lnamebis'
      },
      title: {
        label: 'Title',
        type: 'text',
        element: this.svg.select('#title text'),
        elementbis: '#titlebis'
      },
      alogo: {
        label: 'Agency\'s logo',
        type: 'imagelogo',
        element: this.svg.select('#alogo image'),
        elementbis: '#alogobis'
      },
      atitle: {
        label: 'Agency\'s title',
        type: 'text',
        element: this.svg.select('#atitle text'),
        elementbis: '#atitlebis'
      },
      aname: {
        label: 'Agency\'s name',
        type: 'text',
        element: this.svg.select('#aname text'),
        elementbis: '#anamebis'
      },
      aphone: {
        label: 'Agency\'s phone',
        type: 'phone',
        element: this.svg.select('#aphone text'),
        elementbis: '#aphonebis'
      },
      bphone: {
        label: 'Phone',
        type: 'phone',
        element: this.svg.select('#bphone text'),
        elementbis: '#bphonebis'
      },

      bmail: {
        label: 'Mail',
        type: 'text',
        element: this.svg.select('#bmail text'),
        elementbis: '#bmailbis'
      },
      burl: {
        label: 'Website',
        type: 'text',
        element: this.svg.select('#burl text'),
        elementbis: '#burlbis'
      },
      date: {
        label: 'Date',
        type: 'text',
        element: this.svg.select('#date text'),
        elementbis: '#datebis'
      },
      input1: {
        label: 'Input1',
        type: 'text',
        element: this.svg.select('#input1 text'),
        elementbis: '#input1bis'
      },
      input2: {
        label: 'Input2',
        type: 'text',
        element: this.svg.select('#input2 text'),
        elementbis: '#input2bis'
      },
      input3: {
        label: 'Input3',
        type: 'text',
        element: this.svg.select('#input3 text'),
        elementbis: '#input3bis'
      },
      input4: {
        label: 'Input4',
        type: 'text',
        element: this.svg.select('#input4 text'),
        elementbis: '#input4bis'
      },
      input5: {
        label: 'Input5',
        type: 'text',
        element: this.svg.select('#input5 text'),
        elementbis: '#input5bis'
      },
    }
    let bindi = false;
    for (const id in content) {
      if (elements[id] && elements[id].element) {
        const hasPrefix = elements[id].element.attr('si:has-prefix') ? elements[id].element.attr('si:has-prefix') : ''
          elements[id].element.node.innerHTML = hasPrefix + content[id]
        
        if(this.logoUrl === '' || this.svg.select("#alogo") === null || this.logoUrl === null){
          if(this.svg.select("#alogo") != null){
            this.svg.select("#alogo").node.style.display = "none";
          }
        }else{
          if(id === 'aname' || id ==="atitle"){
          elements[id].element.node.innerHTML = '';
        }
        }

        if (elements[id].type == 'text') {
          var elementbis = this.svg.select('' + elements[id].elementbis + ' text');
          if (elementbis != null) {
            //adjustLetterSpacing(elementbis)
            elementbis.node.innerHTML = elements[id].element.node.innerHTML
            elements[id].element.attr('si:bis', elements[id].elementbis);
          }
            //adjustLetterSpacing(elements[id].element)
            adjustFontSizeToFit(elements[id].element, false)

            if (elementbis != null) {
              adjustFontSizeToFit(elementbis, false)
             

            }
          
        }


        if (elements[id].type == "phone" && elements[id].element.attr('si:phone-format')) {

          var indic = null;

          if (id == "bphone" && this.svg.select("#bindic text") !== null) {
            elements[id].element.attr('si:indic', 'true')
            elements[id].element.attr('si:whichindic', 'bindic')
            indic = this.svg.select('#bindic text')
          } else if (id == "aphone" && this.svg.select("#aindic text") !== null) {
            elements[id].element.attr('si:indic', 'true')
            elements[id].element.attr('si:whichindic', 'aindic')
            indic = this.svg.select('#aindic text')
          }

          const phoneFormat = elements[id].element.attr('si:phone-format')
          const hasBindic = elements[id].element.attr('si:indic') ? true : false
          const phonePrefix = elements[id].element.attr('si:phone-prefix') ? elements[id].element.attr('si:phone-prefix') : ''
          //
          const num = formatPhoneNumber(content[id], phoneFormat, phonePrefix, false, hasBindic)
          //
          if (hasBindic) {
            elements[id].element.node.innerHTML = num.substr(4, 10);
            
            // ajout de parenthese si il y en a dans le design
            var parenthese = indic.node.innerHTML.charAt(0);
            if(parenthese == "("){
              indic.attr('si:numDeco', "(");
              indic.node.innerHTML = "(";
              indic.node.innerHTML += num.substr(0, 3);
              indic.node.innerHTML += ")";
            }else{
              indic.node.innerHTML = num.substr(0, 3);
            }
            
            adjustFontSizeToFit(indic, true);
            //double check to work ;)
            adjustFontSizeToFit(indic, true);
            //
            var elementbis = this.svg.select('' + elements[id].elementbis + ' text');
            if (elementbis != null) {
              elementbis.node.innerHTML = elements[id].element.node.innerHTML;
              elements[id].element.attr('si:bis', elements[id].elementbis);
              indic = this.svg.select('#' + elements[id].element.attr('si:whichindic') + "bis text")
              var parentheseBis = indic.node.innerHTML.charAt(0);
            if(parentheseBis == "("){
              indic.attr('si:numDeco', "(");
              indic.node.innerHTML = "(";
              indic.node.innerHTML += num.substr(0, 3);
              indic.node.innerHTML += ")";
            }else{
              indic.node.innerHTML = num.substr(0, 3);
            }
              adjustFontSizeToFit(indic, true);
            }
          } else {
            elements[id].element.node.innerHTML = num;
            //adjustLetterSpacing(elements[id].element)
            var elementbis = this.svg.select('' + elements[id].elementbis + ' text');
            if (elementbis != null) {
              elementbis.node.innerHTML = elements[id].element.node.innerHTML;
              //adjustLetterSpacing(elementbis)
              elements[id].element.attr('si:bis', elements[id].elementbis);
            }
          }

        }
      }
    }


    return this
  }

  getSVG({
    embedImages = false
  } = {}) {
    if (embedImages) {
      return Promise.all([
        this.photoUrl ? getBase64FromImageUrl(this.photoUrl).then((dataUrl) => {
            this.setPhoto(dataUrl)
          }) : Promise.resolve(),
        this.logoUrl ? getBase64FromImageUrl(this.logoUrl).then((dataUrl) => {
            this.setLogo(dataUrl)
          }) : Promise.resolve(),
      ])
        .then(() => this.svg.outerSVG())
    } else {
      return new Promise((resolve) => {
        const photoUrl = this.photoUrl
        const logoUrl = this.logoUrl

        if (this.originalPhotoUrl) {
          this.setPhoto(this.originalPhotoUrl)
        }
        if (this.originalLogoUrl) {
          this.setLogo(this.originalLogoUrl)
        }

        resolve(this.svg.outerSVG())

        if (photoUrl) {
          this.setPhoto(photoUrl)
        }
        if (logoUrl) {
          this.setLogo(logoUrl)
        }
      })
    }
  }
}
